import * as React from 'react';
import { Box } from '@mui/material';
import { KEY_SIGNATURE_DISPLAYS } from 'Seeds/ExerciseContent/scaleNotation';
import { useSetting } from 'Settings/useSetting';
import { KEY_SIGNATURE_DISPLAY_LABELS } from './keySignatureDisplaySettings';

/** Settings > Practice: write scales with their key signature, or with accidentals only. */
const KeySignatureDisplayControl = () => {
  // Read and written through the settings model (a global, per-user device setting).
  const [display, setDisplay] = useSetting('keySignatureDisplay');

  return (
    <Box sx={{ marginBottom: '24px', fontFamily: 'Lato' }}>
      <Box
        id="key-signature-display-label"
        sx={{
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '16px',
          letterSpacing: '0.01em',
          color: '#ECECEC',
          marginBottom: '10px',
        }}
      >
        Key signature
      </Box>
      <Box
        role="radiogroup"
        aria-labelledby="key-signature-display-label"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        {KEY_SIGNATURE_DISPLAYS.map((option) => {
          const selected = display === option;
          return (
            <Box
              key={option}
              component="button"
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => setDisplay(option)}
              sx={{
                padding: '10px 14px',
                borderRadius: '999px',
                border: selected ? '1px solid #7FD7FF' : '1px solid rgba(255,255,255,0.18)',
                backgroundColor: selected ? 'rgba(127, 215, 255, 0.14)' : 'transparent',
                color: selected ? '#ECECEC' : '#9CA3AF',
                font: 'inherit',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              {KEY_SIGNATURE_DISPLAY_LABELS[option]}
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          marginTop: '10px',
          fontSize: '13px',
          color: 'rgba(236,236,236,0.62)',
        }}
      >
        How scales are written in Exercises.
      </Box>
    </Box>
  );
};

export default KeySignatureDisplayControl;
